module.exports = __webpack_public_path__ + "static/img/TR@3x.380b360d.jpg";